import { AppBar, Toolbar, Typography, Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ChurchIcon from '@mui/icons-material/Church';

function Navbar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="static">
      <Toolbar>
        <ChurchIcon sx={{ mr: 2 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Avisos TIB
        </Typography>
        {!isMobile && (
          <Box>
            <Button color="inherit" component={RouterLink} to="/">
              Início
            </Button>
            <Button color="inherit" component={RouterLink} to="/avisos/novo">
              Novo Aviso
            </Button>
            <Button color="inherit" component={RouterLink} to="/avisos">
              Avisos
            </Button>
            <Button color="inherit" component={RouterLink} to="/exibir">
              Apresentar
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Navbar; 